import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e6615a4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6615a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xinyushan/sdYuShan/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e6615a4')) {
      api.createRecord('0e6615a4', component.options)
    } else {
      api.reload('0e6615a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0e6615a4&scoped=true&", function () {
      api.rerender('0e6615a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberMove/index.vue"
export default component.exports